import { ListItem } from '@/components';
import CopyButton from '@/components/molecules/CopyButton/CopyButton';
import { WalletInterface } from '@/interfaces/WalletInterface';
import {
  formatBalanceToBalanceInUsdString,
  formatStringToFirstAndLast4Characters,
} from '@/utils/formatUtils';
import Image from 'next/image';
import { FC } from 'react';
export interface WalletListItemProps {
  wallet: WalletInterface;
  align?: 'left' | 'center' | 'right';
  showWalletAddressCopyButton?: boolean;
  showWalletAddress?: boolean;
  showWalletBlockchain?: boolean;
  showWalletAggregatedBalanceInUsd?: boolean;
  showFullWalletAddress?: boolean;
}
const WalletListItem: FC<WalletListItemProps> = ({
  wallet,
  align = 'left',
  showWalletAddressCopyButton = true,
  showWalletAddress = true,
  showWalletAggregatedBalanceInUsd = true,
  showWalletBlockchain = false,
  showFullWalletAddress = false,
}) => {
  const walletName = wallet.name;
  const blockchainDisplayName = wallet.blockchainDisplayName;
  const balanceText = formatBalanceToBalanceInUsdString(
    wallet.aggregatedBalanceInUsd,
  );
  const addressText = showWalletAddressCopyButton ? (
    <CopyButton
      value={wallet.address}
      showLabel={false}
      displayValueSize="sm"
      displayValue={
        showFullWalletAddress
          ? wallet.address
          : formatStringToFirstAndLast4Characters(wallet.address)
      }
      displayValueColor="secondary"
      iconSize="sm"
    />
  ) : showWalletAddress ? (
    `Wallet ${
      showFullWalletAddress
        ? wallet.address
        : formatStringToFirstAndLast4Characters(wallet.address)
    }`
  ) : null;
  const subText = showWalletBlockchain
    ? `Network ${blockchainDisplayName}`
    : showWalletAggregatedBalanceInUsd
    ? balanceText
    : addressText;
  const subSubText = showWalletBlockchain
    ? balanceText
    : showWalletAggregatedBalanceInUsd
    ? addressText
    : null;
  const subSubSubText = showWalletBlockchain ? addressText : null;
  return (
    <ListItem
      mainText={walletName}
      subText={subText}
      subSubText={subSubText}
      subSubSubText={subSubSubText}
      leftIcon={
        <Image
          src={`/images/crypto-logos/svg/color/wallet-${wallet.blockchain.toLowerCase()}.svg`}
          alt={blockchainDisplayName}
          width={32}
          height={32}
          loading="lazy"
        />
      }
      align={align}
    />
  );
};
export default WalletListItem;
